<template>
    <div class="principal">
        <NavBar :usarAberto="false" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
            :usarRelatorio="false" :usarRelatorioEstrelaAtend="false" :usarFiltros="true" :usarFiltroSetor="true"
            :usarFiltroTpChamado="true" :usarFiltroPosicao="false" :usarFiltroDatas="true" @filtrar="filtrar()"
            :nomeTela="'Média de Estrelas por Setor'" :usarTrocaVisualizacao="true" :card="false" :tabela="true"
            :grafico="true" :visualizacaoPadrao="'Tabela'" :formatarDataInicioMes="formatarDataInicioMes" />

        <div class="mainDiv">
            <table class="table table-striped" v-show="this.tabela === 'Tabela'">
                <thead>
                    <tr>
                        <th class="col-sm-6 col-md-6">Setor</th>
                        <th class="col-sm-2 col-md-2">Atendimento</th>
                        <th class="col-sm-2 col-md-2">Media das Avaliações</th>
                        <th class="col-sm-2 col-md-2">Porcentagem</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, index) in this.dadosRelatorioTabela" :key="index">
                        <td class="col-sm-6 col-md-6"> {{ d['setorDescricao'] }} </td>
                        <td class="col-sm-2 col-md-2"> {{ d['quantidadeAvaliacoes'] }} </td>
                        <td class="col-sm-2 col-md-2"> {{ d['mediaAvaliacoes'] }} </td>
                        <td class="col-sm-2 col-md-2"> {{ d['mediaAvaliacoesPorcentagem'] }} </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="display justify-content-center" v-show="this.tabela === 'Grafico'">
            <canvas id="MediaAvaliacaoSetorBarra" class="graficoRelatorio">Media Avaliação por Setor</canvas>
        </div>
    </div>
    <ModalEditar :mostrar="existeErro" :tamanhoModal="30">
        <template v-slot:header>
            {{ this.titulo }}
        </template>
        <template v-slot:corpo>
            {{ this.textoErro }}
        </template>
        <template v-slot:rodape>
            <button @click="desativarModal()" class="btn btn-primary">Entendi</button>
        </template>
    </ModalEditar>
</template>

<script>
import api from '@/api/api';
import _versao from '@/../package.json';
import { Chart, CategoryScale, BarController, BarElement, Title, LineController, LinearScale } from 'chart.js';
import store from "@/store/store";
import NavBar from '@/components/NavBar.vue';
import moment from 'moment';
import ModalEditar from '@/components/ModalEditar.vue';

export default {
    name: "relatoriO",
    props: ['formatarDataInicioMes'],
    mounted() {
        // this.formatarDataInicioMes();
        Chart.register(LinearScale, LineController, CategoryScale, BarElement, BarController, Title);
        this.construirTabela(0, 0, this.formatarDataInicioMes(new Date()), new Date());
    },
    data() {
        return {
            versao: _versao.version,
            dados: [],
            dadosRelatorioTabela: [],
            graficoMediaAvaliacaoSetor: null,
            titulo: String(),
            textoErro: String(),
            existeErro: Boolean(),
            tabela: "Tabela"
        };
    },
    methods: {
        retornaData(pData) {
            return new Date(pData);
        },
        async construirTabela(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal) {
            let sql = `SELECT 
                       S.DESCRICAO SETOR, S.ID , count(*) , sum(C.AVALIACAO) , avg(C.AVALIACAO), list(C.AVALIACAO) , 
                       (100 * avg(C.AVALIACAO) / 5.0) || '%'
                       FROM CHAMADO C 
                       JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO
                       JOIN LEITO L ON L.ID = C.ID_LEITO 
                       JOIN QUARTO Q ON Q.ID = L.ID_QUARTO 
                       JOIN SETOR S ON S.ID = Q.ID_SETOR 
                       WHERE 
                       C.POSICAO = 'FE'
                      `;
            // AND Q.ATIVO = 'TRUE'`
            (pValorFiltroSetor > 0) ? sql += `AND S.ID = ${pValorFiltroSetor} ` : "";

            (pValorFiltroTPChamado > 0) ? sql += `AND T.ID = ${pValorFiltroTPChamado} ` : "";

            if (this.retornaData(pDataInicial) > this.retornaData(pDataFinal)) {
                this.titulo = "Aviso";
                this.textoErro = "A Data Inicial não pode ser maior que a Data Final";
                this.existeErro = true;
            } else {
                let auxDataInicial = moment(pDataInicial).format("DD.MM.YYYY");
                let auxDataFinal = moment(pDataFinal).format("DD.MM.YYYY");
                sql += `AND C.DATA between '${auxDataInicial}' and '${auxDataFinal}'
                        group by 1,2`;

                await api.listarSql(sql)
                    .then(resp => {
                        this.dadosRelatorioTabela = [];
                        resp.forEach((r) => {
                            let aux = {};
                            aux["setorDescricao"] = r[0];
                            aux["idSetor"] = r[1];
                            aux["quantidadeAvaliacoes"] = r[2];
                            aux["somaAvaliacoes"] = r[3];
                            aux["mediaAvaliacoes"] = r[4];
                            aux["listagemAvaliacoes"] = r[5];
                            aux["mediaAvaliacoesPorcentagem"] = r[6];
                            this.dadosRelatorioTabela.push(aux);
                        });
                    });
            }
        },

        async construirGraficoMediaAvaliacaoSetor() {
            const graficoMediaAvaliacaoSetorBarra = document.querySelector("#MediaAvaliacaoSetorBarra").getContext("2d");
            if (this.graficoMediaAvaliacaoSetor) {
                this.graficoMediaAvaliacaoSetor.destroy();
            }

            let setoresDesc = [];//Media de avaliacao por setor
            let media = [];

            this.dadosRelatorioTabela.forEach((d) => {
                setoresDesc.push(d.setorDescricao);
                media.push(d.mediaAvaliacoes);
            });

            media.push(5);
            setoresDesc = [...new Set(setoresDesc)];

            const hoverValue = {
                id: 'hoverValue',
                afterDatasetsDraw(chart) {
                    const { ctx, data, options } = chart;
                    chart.getActiveElements().forEach((active) => {
                        const value = data.datasets[active.datasetIndex].data[active.index].toFixed(0) + "★";
                        const fontSize = options.hoverRadius;
                        ctx.save();
                        ctx.textAlign = 'center';
                        ctx.font = `bold ${fontSize}px sans-serif`;
                        ctx.lineDashOffset = 10;
                        ctx.fillText(value, active.element.x, active.element.y);
                        ctx.restore();
                    });
                }
            };

            if (this.dadosRelatorioTabela.length > 0) {
                this.graficoMediaAvaliacaoSetor = new Chart(graficoMediaAvaliacaoSetorBarra, {
                    type: "bar",
                    data: {
                        labels: setoresDesc,
                        datasets: [{
                            label: 'My First Dataset',
                            data: media,
                            maxBarThickness: 35,
                            backgroundColor: ['rgba(255, 99, 132, 0.2)'],
                            borderColor: ['rgb(255, 99, 132)'],
                            borderWidth: 1
                        }]
                    },
                    options: {
                        indexAxis: "x",
                        hoverRadius: 20,
                        plugins: {
                            title: {
                                display: true,
                                text: 'Média de Estrelas por Setor',
                                padding: {
                                    top: 10,
                                    bottom: 30
                                },
                                font: {
                                    size: 20
                                }
                            }
                        }
                    },
                    plugins: [hoverValue]
                });
            }
        },

        retornaDataFormatada(pData) {
            return moment(pData).format("DD/MM/YYYY");
        },

        async filtrar(aux, pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pVisualizacao) {
            this.tabela = pVisualizacao;
            await this.construirTabela(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal);
            if (pVisualizacao === "Grafico") {
                this.construirGraficoMediaAvaliacaoSetor();
            }
        },

        deslogar() {
            sessionStorage.removeItem("TokenReguaPainel");
            this.$router.back();
        },

        desativarModal() {
            this.existeErro = false;
        },

    },
    computed: {
        setores() {
            return store.state.setores;
        },
        config() {
            return store.state.config;
        },
        tipoChamado() {
            return store.state.tipoChamado;
        },
    },
    components: { NavBar, ModalEditar }
};
</script>

<style scoped>
.display {
    display: flex;
}
</style>